import { N05_03 } from "./N05_03";

export const N05_02 = {
  selectedValueColumn: "DrillKey",
  selectedTitle: "District",
  visual: [
    {
      columns: 12,
      rows: 2,
      visual: {
        id: 1,
        type: "advancedTable",
        colorTheme: "colorTheme1",
        title: "District",
        binding: {
          data: {
            columns: [
              {
                name: "Manager Name",
                columnName: "FSName",
                width: "300px",
                align: "left",
                sortable: true,
              },
              {
                name: "District",
                columnName: "DistrictName",
                width: "300px",
                align: "left",
                sortable: true,
              },
              {
                name: "Number Of Branches",
                columnName: "NumberOfBranches",
                width: "300px",
                align: "center",
                sortable: true,
              },
            ],
            title: "DistrictName",
            endpoint: "SFE_N05.2",
            parameters: [
              { key: "CycleCode", value: "CP1" },
              { key: "CycleYear", value: "2026" },
              { key: "DrillKey", value: "" },
            ],
          },
          context: {
            point: {
              onClick: N05_03,
            },
          },
        },
      },
    },
  ],
};
